import { useMutation } from '@tanstack/react-query';
import { apiClientOld } from '@/_config/lib/axios/api-client-old';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';

const putSetDeliverymenOffline = async ({
  deliverymenIds,
}: {
  deliverymenIds: string[];
}) =>
  apiClientOld
    .put('/entregadores/set-offline', {
      entregadoresIds: deliverymenIds,
    })
    .then(response =>
      handleResponseSuccess(
        response,
        'Status dos entregadores alterado com sucesso!',
      )(),
    )
    .catch(
      handleResponseThrowError(
        'Não foi possível alterar o status dos entregadores.',
      ),
    );

export const useSetDeliverymenOffline = () => {
  return useMutation({
    mutationFn: (deliverymenIds: string[]) =>
      putSetDeliverymenOffline({ deliverymenIds }),
  });
};
